import Datastore from "@/developing/datastore";
import store from '@/store'; // Vuex store for import the module's states.
import local from "./data-local";
import dev from "./data-dev";

//
export const state = { Datastore, store: store.state, local, dev }

//
export const createList = async function (channel, list_type, topics) {
  // Get ID of Topics to Generate A List
  // with condition of list (All, Recent, )
  // console.log(channel, list_type, topics);
  if (!channel || !list_type || !topics) { return }

}

//
export const constructTopicsFromList = async function (channel, list_type) {
  // console.log("constructTopicFromList");

  // const limit = 10;
  // const cursor = 0;

  let storedList = await Datastore.Message.getList(channel, list_type);
  let list = null;
  let topics = [];

  // console.log("storedList", storedList);

  if (typeof storedList === "undefined") {
    // console.log("Request server to generate and send back a new list");
    // list = createNewList(channel, type);
  } else {
    list = storedList.data;
  }

  // console.log("Check constructTopicsFromList", list);

  if (Array.isArray(list)) {
    let diff = [...list];
    for (let i = list.length - 1; i >= 0; i -= 1) {
      const item = list[i];
      const topic = await Datastore.Message.load("topic", channel, item.id);
      if (topic) {
        diff.splice(i, 1);
        topics.push(topic);
      }
    }

    // console.log("diff", diff);

    if (diff.length > 0) {
      diff = diff.map(({ id }) => ({ id }));
      const { status, data } = await store.dispatch("Communication/getMessageTopicsByIds", { channel, list: diff });
      // console.log("Check", status, data);

      if (status.success && data[channel]) {
        topics = [...topics, ...data[channel]];
        topics.map(topic => Datastore.Message.save("topic", channel, topic.id, topic));
      }
    }
  }

  return topics
}

// Construct Messages to Show on UI
export const constructMessagesFromList = function (channel, list_id) {
  if (!channel || !list_id) {
    return // Return error
  }

  const topics = [];
  const messages = [];

  const list = Datastore.Message.load(`list/${channel}`, list_id);
  // console.log("List in constructMessageFromList", list, channel, list_id);

  if (list && Array.isArray(list.list)) {

    // console.log("Load topics and messages to create a new list")
    for (let topicItem of list.list) {
      const topic = Datastore.Message.load("topic/pm", topicItem.id);


      if (topic) {
        topics.push(topic);

        if (topic.messageIndex.length > 0) {

          for (let messageItem of topic.messageIndex) {
            const message = Datastore.Message.load("message/pm", messageItem.id);
            messages.push(message);
          }
        }
      }
    }
  }

  return { topics, messages };
}

//
export async function loadTopicList(channel = "all", type = "recent") {

  const data = { list: {} };

  switch (channel) {
    case "pm":
      data.list.pm = await getPMTopicList(type);
      break;
    case "chat":
      data.list.pm = await getChatTopicList(type);
      break;
    case "webboard":
      data.list.pm = await getWebboardTopicList(type);
      break;
    default:
      data.list.pm = await getPMTopicList(type);
      data.list.chat = await getChatTopicList(type);
      data.list.webboard = await getWebboardTopicList(type);
      break;
  }

  return data;
  /*
  // Create Message
  storeMessagesToCache({ channel: "pm", messageKey: "privateMessageReplies", data: pm });
  storeMessagesToCache({ channel: "chat", messageKey: "chatMessage", data: chat });
  storeMessagesToCache({ channel: "webboard", messageKey: "webBoardReplies", data: webboard });

  */
}

//
export function getNewUnreadMessage(channel) {
  return Datastore.Message.getState(channel, "unread") || 0;
  // if (channel && this.$data.$local.messagePool[channel]) {
  //   const unreadMessages = this.$data.$local.messagePool[channel].filter(message => message.unread === true);
  //   return unreadMessages.length;
  // }
}


//////////////////////////
//*  Private Functions  */
//////////////////////////

//
async function getPMTopicList(type) {
  // console.log("getPMTopicList", type);

  const pool = Datastore.Message.list.has(`pm/${type}`);
  // console.log("PM Pool", pool);
  if (pool) {
    // Send cache key to check/get update, if exists
  } else {
    // const idb_pm_recent_list = null;
    const idb = await Datastore.Message.idb.list.get(`pm/${type}`);
    // console.log("PM IDB", idb);

    if (idb) {
      Datastore.Message.list.set(`pm/recent`, idb);
      return idb;
    } else {
      const response = await store.dispatch("Communication/getRecentMessageList", { channel: "pm", type });
      // console.log("Check", response);

      const { status, data } = response;
      if (!status) {
        // console.log("Error on Communication/getRecentMessageList");
        return
      }

      if (status.success && data) {
        const { pm } = data;
        if (pm) {
          await Datastore.Message.save("list", "pm", type, pm);
          return pm;
        }
      }
    }
  }
}

//
async function getChatTopicList(type) {
  // console.log("getChatTopicList", type);

  const pool = Datastore.Message.list.has(`chat/${type}`);
  // console.log("Chat Pool", pool);
  if (pool) {
    // Send cache key to check/get update, if exists
  } else {
    // const idb_pm_recent_list = null;
    const idb = await Datastore.Message.idb.list.get(`chat/${type}`);
    // console.log("Chat IDB", idb);

    if (idb) {
      Datastore.Message.list.set(`chat/recent`, idb);
      return idb;
    } else {
      const response = await store.dispatch("Communication/getRecentMessageList", { channel: "chat", type });
      const { status, data } = response;
      if (status.success && data) {
        const { chat } = data;
        if (chat) {
          await Datastore.Message.save("list", "chat", type, chat);
          return chat;
        }
      }
    }
  }
}

//
async function getWebboardTopicList(type) {
  // console.log("getWebboardTopicList", type);

  const pool = Datastore.Message.list.has(`webboard/${type}`);
  // console.log("Webboard Pool", pool);
  if (pool) {
    // Send cache key to check/get update, if exists
  } else {
    // const idb_webboard_recent_list = null;
    const idb = await Datastore.Message.idb.list.get(`webboard/${type}`);
    // console.log("Webboard IDB", idb);

    if (idb) {
      Datastore.Message.list.set(`webboard/recent`, idb);
      return idb;
    } else {
      const response = await store.dispatch("Communication/getRecentMessageList", { channel: "webboard", type });
      const { status, data } = response;
      if (status.success && data) {
        const { webboard } = data;
        if (webboard) {
          await Datastore.Message.save("list", "webboard", type, webboard);
          return webboard;
        }
      }
    }
  }
}

/*
function storeMessagesToCache({ channel, messageKey, data } ) {
  // const list = [];

  // Message.saveList(channel, data);

  // for (let topic of data) {
  //   topic.messageIndex = [];

  //   // // Save all message to flatmap
  //   if (topic[messageKey]) {
  //     for (let message of topic[messageKey]) {
  //       Message.save(`message/${channel}`, message.id, message);
  //       // console.log(message);
  //       topic.messageIndex.push({ id: message.id, timestamp: new Date(message["sendDate"]).getTime(), read: message.readDate ? true : false });
  //     }
  //     // delete topic[messageKey];
  //   }

  //   // console.log(topic);
  //   list.push({ id: topic.id, timestamp: new Date(topic["sendDate"]).getTime(), read: topic.readDate ? true : false });
  //   Message.save(`topic/${channel}`, topic.id, topic);

  // }

  // Message.save(`list/${channel}`, "all", { list });
}
*/

//
/* function createNewList (channel, type) {
  const listOfAll = Message.getList(channel, "all");
  let list = null;
  if ((listOfAll) && listOfAll.list) {
    if (listOfAll.list.length > 1) {
      list = [ ...listOfAll.list ];
      if (type === "recent") {
        list = listOfAll.list.sort((a, b) => b.timestamp - a.timestamp);
      } else if (type === "unread") {
        list = listOfAll.list.filter(x => !x["read"]).sort((a, b) => b.timestamp - a.timestamp);
      }

      Message.save(`list/${channel}`, type, { list });
    }
  }
  return list
}
*/
